import React from "react";

const TotalProduct = ({ totalProduct }) => {
  return (
    <div className='flex justify-center items-center text-center'>
      <div className='text-xl font-semibold'>
        <p>Total Item</p>
        <p className='text-5xl'>{totalProduct}</p>
      </div>
    </div>
  );
};

export default TotalProduct;
